import api from "../../../services/api";

const BASE_PATH = "/api/v1/procurement";

export const generateMemo = async (requestId, payload) => {
  const response = await api.post(
    `${BASE_PATH}/requests/${requestId}/memo`,
    payload,
  );
  return response.data;
};

export const getMemoByRequestId = async (requestId) => {
  const response = await api.get(`${BASE_PATH}/requests/${requestId}/memo`);
  return response.data;
};

export const downloadMemoPdf = async (memoId) => {
  const response = await api.get(`${BASE_PATH}/memo/${memoId}/download`, {
    responseType: "blob",
  });
  return response;
};

export const getMemoVersions = async (requestId) => {
  const response = await api.get(
    `${BASE_PATH}/requests/${requestId}/memo/versions`,
  );
  return response.data;
};

export default {
  generateMemo,
  getMemoByRequestId,
  downloadMemoPdf,
  getMemoVersions,
};
